export default "__VITE_ASSET__2f6191fa__"